import { render } from "./AccountingSettingsTabContent.vue?vue&type=template&id=1a828ede&scoped=true&ts=true&lang=pug"
import script from "./AccountingSettingsTabContent.vue?vue&type=script&lang=ts"
export * from "./AccountingSettingsTabContent.vue?vue&type=script&lang=ts"

import "./AccountingSettingsTabContent.vue?vue&type=style&index=0&id=1a828ede&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a828ede"]])

export default __exports__